import React, { useState } from 'react'
import Popup from '../../../../../components/popup/Popup'
import { IBuffetDishWithImplInfoDto } from '../../../../../core/api/dto/BuffetDishDto'
import AppBtn, {
  AppBtnColor,
  AppBtnSize,
} from '../../../../../components/btn/AppBtn'
import { AppImagePopup } from '../../../../../components/AppImagePopup/AppImagePopup'
import { useTranslation } from 'react-i18next'

interface PredictionDishPopupProps {
  dish: IBuffetDishWithImplInfoDto
  onContinue: (dish: IBuffetDishWithImplInfoDto, orderIds?: string[]) => void
  onClosePopup: () => void
  imageFromCamera: string
  orderIds?: string[]
}

export const PredictionDishPopup = ({
  dish,
  onClosePopup,
  imageFromCamera,
  onContinue,
  orderIds,
}: PredictionDishPopupProps) => {
  const onContinueHandler = () => onContinue(dish, orderIds)

  return (
    <Popup closePopup={onClosePopup} className="popup-width">
      <div className="prediction-popup-wrap">
        <div className="photos">
          <PhotoBlock
            title="Эталон"
            src={dish?.image || dish?.imageOnS3 || ''}
          />
          <PhotoBlock title="Факт" src={imageFromCamera} fromCamera />
        </div>
        <div className="btns mt-20">
          <AppBtn
            title="Отмена"
            sized={AppBtnSize.md}
            color={AppBtnColor.outlineViolet}
            className="full-width"
            onClick={onClosePopup}
          />
          <AppBtn
            title="Продолжить"
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            className="full-width"
            onClick={onContinueHandler}
          />
        </div>
      </div>
    </Popup>
  )
}

interface PhotoBlockProps {
  title: string
  src: string
  fromCamera?: boolean
}

const PhotoBlock = ({ title, src, fromCamera }: PhotoBlockProps) => {
  const { t } = useTranslation()
  const [isZoomPopup, setIsZoomPopup] = useState(false)
  const onOpenPopup = () => setIsZoomPopup((prev) => !prev)
  return (
    <>
      {isZoomPopup && (
        <AppImagePopup title={t(title)} img={src} setActive={onOpenPopup} />
      )}
      <div className="photo-block">
        <div>{t(title)}</div>
        <div
          className="photo"
          style={fromCamera ? {} : { backgroundImage: `url(${src})` }}
        >
          {fromCamera && <img src={src} alt={t(title)} />}
          {!src && (
            <div className="add-photo-block">
              <i className="an-ico an-ico-photo-add" />
            </div>
          )}
          {!!src && (
            <div className="zoom-ico-block" onClick={onOpenPopup}>
              <i className="an-ico an-ico-search" />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
